export default {"src":"/_next/static/media/grey-clock.dfde0c4d.svg","height":12,"width":12};